import React, { useRef, useEffect, useCallback } from "react";
import anime from "animejs";

interface SVGAnimationProps {
    animationStart: string[];
    animationEnd: string[];
    duration?: number;
    loop?: boolean;
    strokeColor?: string;
    strokeWidth?: number;
    minHeight?: string;
    maxHeight?: string;
    style?: React.CSSProperties;
}

const SVGAnimation: React.FC<SVGAnimationProps> = React.memo(({
    animationStart,
    animationEnd,
    duration = 2500,
    loop = true,
    strokeColor = "#294C72",
    strokeWidth = 2.98649,
    minHeight = "60vh",
    maxHeight = "80vh",
    style = {}
}) => {
    const svgRef = useRef<SVGSVGElement>(null);

    const createAnimationTimeline = useCallback(() => {
        const timeline = anime.timeline({
            easing: "easeInOutSine",
            duration,
            loop,
        });

        animationStart.forEach((startPath, index) => {
            timeline.add(
                {
                    targets: `#path-${index}`,
                    d: [
                        { value: animationEnd[index], duration },
                        { value: startPath, duration },
                    ],
                },
                0
            );
        });

        return timeline;
    }, [animationStart, animationEnd, duration, loop]);

    useEffect(() => {
        const timeline = createAnimationTimeline();
        return () => {
            timeline.pause();
        };
    }, [createAnimationTimeline]);

    return (
        <svg
            ref={svgRef}
            style={{ ...style, minHeight, maxHeight }}
            viewBox="0 0 540 479"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {animationStart.map((path, index) => (
                <path
                    key={index}
                    id={`path-${index}`}
                    d={path}
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            ))}
        </svg>
    );
});

export default SVGAnimation;
